import React from 'react';

import LoadingPage from './LoadingPage';

const LazyRoute = ({ children }: React.PropsWithChildren) => {
  return <React.Suspense fallback={<LoadingPage />}>{children}</React.Suspense>;
};

export default LazyRoute;
